import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/App";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] bg-black/60" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="/images/logo.png" alt="BABYLON" className="h-8 w-auto" />
            <p className="mt-3 font-mono text-[9px] tracking-[0.4em] uppercase text-gold/70">
              Conciergerie horlogère privée
            </p>
            <p className="mt-6 font-display italic text-xl text-stone2">
              Votre garde-temps. Nos connexions.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-stone2/60 mb-5">Navigation</p>
            <ul className="space-y-3">
              {[
                { id: "babylon", label: "Le concept" },
                { id: "processus", label: "Comment ça fonctionne" },
                { id: "recherches", label: "Nos recherches" },
                { id: "faq", label: "FAQ" },
                { id: "demande", label: "Faire une demande" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-stone2 hover:text-gold transition-colors duration-300"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-stone2/60 mb-5">Informations</p>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://instagram.com/babylon.private"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2.5 text-sm text-stone2 hover:text-gold transition-colors duration-300"
                  data-testid="footer-instagram-link"
                >
                  <Instagram size={14} strokeWidth={1.5} /> Instagram — @babylon.private
                </a>
              </li>
              <li>
                <a href="mailto:Quentin.pontif@gmail.com" className="text-sm text-stone2 hover:text-gold transition-colors duration-300" data-testid="footer-contact-link">
                  Contact — Quentin.pontif@gmail.com
                </a>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-sm text-stone2 hover:text-gold transition-colors duration-300" data-testid="footer-mentions-link">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-sm text-stone2 hover:text-gold transition-colors duration-300" data-testid="footer-privacy-link">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-sm text-stone2 hover:text-gold transition-colors duration-300" data-testid="footer-cgv-link">
                  Conditions générales de vente
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-stone2/50">
            © 2026 BABYLON — Conciergerie horlogère privée. Tous droits réservés.
          </p>
          <p className="text-xs text-stone2/40 max-w-md sm:text-right">
            Les modèles présentés sont des exemples de recherches, non un catalogue.
            BABYLON est indépendant des maisons citées.
          </p>
        </div>
      </div>
    </footer>
  );
}
